import React from 'react';
import c from 'classnames';

export default function IconBrowser(props: { className?: string }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 460 460"
            xmlSpace="preserve"
            className={c('fill-current', props.className)}
        >
            <path
                d="M60.438 68.311v227.442c0 15.095 12.237 27.332 27.332 27.332h344.898c15.095 0 27.332-12.237 27.332-27.332V68.311H60.438z"
                fill="#ecf0f1"
            />
            <path
                d="M460 38.153c0-15.095-12.237-27.332-27.332-27.332H87.77c-15.095 0-27.332 12.237-27.332 27.332V68.31H460V38.153z"
                fill="#d2d7d8"
            />
            <path
                d="M110.803 48.776H90.657c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h20.146c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM161.168 48.776h-20.146c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h20.146c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735z"
                fill="#e67e22"
            />
            <path
                d="M399.562 138.883c0-15.095-12.237-27.332-27.332-27.332H27.332C12.237 111.551 0 123.788 0 138.883v31.53h399.562v-31.53z"
                fill="#8fa6b4"
            />
            <path
                d="M0 170.413v226.069c0 15.095 12.237 27.332 27.332 27.332H372.23c15.095 0 27.332-12.237 27.332-27.332V170.413H0z"
                fill="#acbdc6"
            />
            <path
                d="M380.309 170.413v205.106c0 15.095-12.237 27.332-27.332 27.332H8.079c-2.624 0-5.159-.377-7.561-1.068 2.469 12.557 13.533 22.031 26.814 22.031H372.23c15.095 0 27.332-12.237 27.332-27.332V170.413h-19.253z"
                opacity=".49"
                fill="#d0d5d9"
            />
            <path
                d="M50.365 149.506H30.219c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h20.146c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM100.73 149.506H80.584c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h20.146c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735z"
                fill="#ffcd02"
            />
            <path
                d="M251.825 230.09H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h211.533c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM282.044 290.528H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h241.752c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM261.898 381.185H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h221.606c4.272 0 7.735 3.463 7.735 7.735 0 4.271-3.463 7.735-7.735 7.735zM161.168 260.309H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h120.876c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM211.533 320.747H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h171.241c4.272 0 7.735 3.463 7.735 7.735s-3.463 7.735-7.735 7.735zM191.387 350.966H40.292c-4.272 0-7.735-3.463-7.735-7.735s3.463-7.735 7.735-7.735h151.095c4.272 0 7.735 3.463 7.735 7.735 0 4.271-3.463 7.735-7.735 7.735z"
                fill="#ffcf6d"
            />
            <path
                d="M411.36 354.947v-25.524c0-17.928-14.533-32.461-32.461-32.461s-32.461 14.533-32.461 32.461v25.524H320.97v-27.723c0-31.993 25.936-57.929 57.929-57.929s57.929 25.936 57.929 57.929v27.723H411.36z"
                fill="#f9b65f"
            />
            <path
                d="M430.063 449.178H327.735c-16.534 0-29.937-13.403-29.937-29.937v-64.295H460v64.295c0 16.534-13.403 29.937-29.937 29.937z"
                fill="#de3e30"
            />
            <path
                d="M444.873 354.947v49.376c0 17.052-13.824 30.876-30.876 30.876H313.548c-4.329 0-8.449-.895-12.189-2.503 5.175 9.8 15.462 16.483 27.316 16.483h100.449c17.053 0 30.876-13.824 30.876-30.876v-63.355h-15.127z"
                opacity=".49"
                fill="#d0d5d9"
            />
            <path
                d="M378.899 421.384c-4.272 0-7.735-3.463-7.735-7.735v-23.172c0-4.272 3.463-7.735 7.735-7.735s7.735 3.463 7.735 7.735v23.172c.001 4.272-3.463 7.735-7.735 7.735z"
                fill="#fff"
            />
        </svg>
    );
}
